import React, { useCallback } from 'react'
import { Button, Form, Input, Typography } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import ResendOTP from '../LoginOTP/ResendOTP'

const { Text } = Typography

const TwoFactorRequiredForm = ({
  onSubmit,
  onResend,
  email,
  resendLoading,
  changeEmailOTP,
  loading,
}) => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()

  const formatter = useCallback((str) => str.replace(/[^0-9]/g, ''), [])

  const handleResetOTP = useCallback(() => {
    form.setFieldValue('code', '')
    if (changeEmailOTP) {
      form.setFieldValue('new_code', '')
    }
  }, [form, changeEmailOTP])

  const handleSubmit = useCallback(
    (values) => {
      onSubmit(values, handleResetOTP)
    },
    [onSubmit, handleResetOTP],
  )

  const handleChangeOTP = useCallback(
    (str, fieldName) => {
      if (str.length === 6) {
        if (changeEmailOTP) {
          const currentValues = form.getFieldsValue()
          const codeValue = fieldName === 'code' ? str : currentValues.code || ''
          const newCodeValue = fieldName === 'new_code' ? str : currentValues.new_code || ''

          // Submit hanya jika kedua OTP sudah terisi 6 digit
          if (codeValue.length === 6 && newCodeValue.length === 6) {
            handleSubmit({ code: codeValue, new_code: newCodeValue })
          }
        } else {
          handleSubmit({ code: str })
        }
      }
    },
    [handleSubmit, changeEmailOTP, form],
  )

  const onKeyDownOtp = useCallback((event) => {
    if (event.code === 'Enter') {
      event.preventDefault()
    }
  }, [])

  return (
    <Form layout="vertical" onFinish={onSubmit} style={{ marginTop: 15 }} form={form}>
      <Form.Item
        name="code"
        rules={[
          {
            required: true,
            message: formatMessage({
              id: 'please_input_the_verification_code',
            }),
          },
        ]}
        style={{ textAlign: 'center' }}
        label={changeEmailOTP ? formatMessage({ id: 'old_email_otp_code' }) : undefined}
      >
        <Input.OTP
          inputType="number"
          length={6}
          autoFocus
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '16px',
            width: 300,
            margin: '0 auto',
          }}
          formatter={formatter}
          onChange={(str) => handleChangeOTP(str, 'code')}
          onKeyDown={onKeyDownOtp}
          size="large"
        />
      </Form.Item>
      {changeEmailOTP && (
        <Form.Item
          name="new_code"
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'please_input_the_verification_code',
              }),
            },
          ]}
          style={{ textAlign: 'center' }}
          label={formatMessage({ id: 'new_email_otp_code' })}
        >
          <Input.OTP
            inputType="number"
            length={6}
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '12px',
              marginBottom: '16px',
              width: 300,
              margin: '0 auto',
            }}
            formatter={formatter}
            onChange={(str) => handleChangeOTP(str, 'new_code')}
            onKeyDown={onKeyDownOtp}
            size="large"
          />
        </Form.Item>
      )}
      <div className="text-center" style={{ marginTop: 20 }}>
        <Button loading={loading} block type="primary" htmlType="submit">
          {formatMessage({ id: 'verify_code' })}
        </Button>
      </div>
      {typeof onResend === 'function' && (
        <div style={{ textAlign: 'center', display: 'block', marginTop: 20 }}>
          <div>
            <Text type="secondary">
              {formatMessage({ id: 'not_receive_verification_code_from_email' })}
            </Text>
          </div>
          <div>
            <Text type="secondary">
              {formatMessage({ id: 'please_check_your_email_folder_spam' })}
            </Text>
          </div>
          <ResendOTP
            hideDescription
            onResend={onResend}
            loading={resendLoading}
            canResendWithChannel
          />
        </div>
      )}
      <div className="text-center" style={{ marginTop: 20 }}>
        <Text type="secondary">
          <FormattedMessage
            id="need_help"
            values={{
              callCenterLink: (
                <a
                  className="text-primary"
                  href={`https://api.whatsapp.com/send?phone=6285232300100&text=Saya%20user%20kledo%20dengan%20email%20${email}%20mengalami%20kendala%20login.`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {formatMessage({ id: 'bankConnect.sales_contact' })}
                </a>
              ),
            }}
          />
        </Text>
      </div>
    </Form>
  )
}

export default TwoFactorRequiredForm
